export default function (settings) {
    const { locales } = useI18n();
    const localizedSettings = {};

    if (settings) {
        locales.value.forEach(l => localizedSettings[l.code] = settings.filter(item => item.language === l.code));
    }

    return localizedSettings;
}